import { useTranslation } from 'react-i18next';
import { TypeToConfirmDialog } from '@/shared/components/custom/type-to-confirm-dialog/TypeToConfirmDialog';

interface OrgDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  orgName: string;
  isPending: boolean;
  onConfirm: () => Promise<void>;
}

export function OrgDeleteDialog({
  open,
  onOpenChange,
  orgName,
  isPending,
  onConfirm,
}: OrgDeleteDialogProps) {
  const { t } = useTranslation('settings');

  return (
    <TypeToConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('orgInfo.deleteDialog.title')}
      description={t('orgInfo.deleteDialog.typeToConfirm')}
      confirmValue={orgName}
      confirmLabel={t('orgInfo.deleteDialog.typeToConfirm')}
      onConfirm={() => void onConfirm()}
      isPending={isPending}
      confirmButtonLabel={t('orgInfo.deleteDialog.confirmButton')}
      destructive
      testId="settings-org-delete"
    >
      <div className="rounded-lg border border-destructive/30 bg-destructive/5 p-4 space-y-3">
        <p className="text-sm font-medium text-destructive">{t('orgInfo.deleteDialog.warning')}</p>
        <ul className="text-sm text-muted-foreground space-y-1.5 list-disc list-inside">
          <li>{t('orgInfo.deleteDialog.consequence1')}</li>
          <li>{t('orgInfo.deleteDialog.consequence2')}</li>
          <li>{t('orgInfo.deleteDialog.consequence3')}</li>
        </ul>
      </div>
    </TypeToConfirmDialog>
  );
}
